import React from 'react'
import { Prompt } from 'react-router'

import ConfirmationModal from './ConfirmationModal'

const OnLeaveModal: React.FC<{
  confirmText: string
  onCancel(location: Record<string, any>): void
  cancelText: string | boolean
  title: string
  message: string
  isPromptedWhen: boolean
  shouldAllowTransition(location: Record<string, any>): boolean
  shouldCloseOnDiscard: boolean
}> = ({
  confirmText,
  cancelText,
  onCancel,
  title,
  message,
  isPromptedWhen,
  shouldCloseOnDiscard,
  shouldAllowTransition
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [nextLocation, updateNextLocation] = React.useState(null)

  return (
    <>
      <Prompt
        message={(nextLocation) => {
          if (typeof shouldAllowTransition === 'function') {
            if (shouldAllowTransition(nextLocation)) {
              return true
            }
          }
          updateNextLocation(nextLocation)
          setIsModalOpen(true)
          return isModalOpen
        }}
        when={isPromptedWhen}
      />
      <ConfirmationModal
        cancelText={cancelText}
        confirmButtonType="primary"
        confirmText={confirmText}
        message={message}
        open={isModalOpen}
        title={title}
        onCancel={(opts) => {
          if (opts.discardModal && shouldCloseOnDiscard) {
            setIsModalOpen(false)
          } else {
            onCancel(nextLocation)
            setIsModalOpen(false)
          }
        }}
        onConfirm={() => {
          setIsModalOpen(false)
        }}
      />
    </>
  )
}

export default OnLeaveModal
